
















import { Component, Vue } from 'vue-property-decorator';

import Header from '../common/header.vue';
import Banner from './banner.vue';
import Partners from './partners.vue';
import WeMedia from './we-media.vue';
import WeMedib from './we-medib.vue';
import Customized from './customized.vue';
import Feixiao from './feixiao.vue';
import Business from './business.vue';
import ContactUs from './contact-us.vue';


@Component({
    components: {
        Header,
        Banner,
        Partners,
        WeMedia,
        WeMedib,
        Business,
        ContactUs,
        Customized,
        Feixiao,
    },
})

export default class Index extends Vue {

}
